import React from 'react';
import {
  Bell, Home, Target, DollarSign, HelpCircle,
  Headphones, Settings, ChevronRight, ShieldCheck,
  SubscriptIcon, Crown
} from 'lucide-react';
import { color } from 'framer-motion';

export const MENU_ITEMS = [
  { icon: Home, label: 'Home', path: '/worker-dashboard', color: '#0491e1', bg: 'rgba(4,145,225,0.12)' },
  { icon: Target, label: 'My Jobs', path: '/bid-jobs', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  { icon: DollarSign, label: 'Earnings', path: '/worker-earnings', color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
  { icon: ShieldCheck, label: 'KYC Verification', path: '/worker-kyc', color: '#0491e1', bg: 'rgba(4,145,225,0.12)' },
  { icon: Bell, label: 'Notifications', path: '/worker-notifications', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
  { icon: HelpCircle, label: 'FAQs', path: '/worker-faq', color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)' },
  { icon: Headphones, label: 'Support', path: '/worker-support', color: '#0491e1', bg: 'rgba(4,145,225,0.12)' },
      { icon: Crown, label: 'Subscriptico History', path: '/subscription-history', color:'#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  { icon: Settings, label: 'Settings', path: '/worker-settings', color: '#484745', bg: 'rgba(72,71,69,0.10)' },

];

const WorkerMenu = ({ handleProtectedNavigation }) => {
  return (
    <div className="wp-menu">
      {MENU_ITEMS.map(item => {
        const Icon = item.icon;
        return (
          <button
            key={item.path}
            className="wp-menu-item"
            onClick={() => handleProtectedNavigation(item.path)}
          >              <div className="wp-menu-item__icon" style={{ background: item.bg, color: item.color }}>
              <Icon size={18} />
            </div>
            <span className="wp-menu-item__label">{item.label}</span>
            <ChevronRight size={16} className="wp-menu-item__arrow" />
          </button>
        );
      })}
    </div>
  );
};

export default WorkerMenu;